import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { getParents, type Parent } from './api'

export const parentsQueryOptions = () =>
    queryOptions<Parent[]>({
        queryKey: ['parents', 'with-students-v1'],
        queryFn: () => getParents(),
    })

export function useParents() {
    return useSuspenseQuery(parentsQueryOptions())
}
